/**
 * SHER-244 — read side of the survey-name snapshot.
 *
 * Walk a submission's records, look for a medical_history_template
 * record whose JSON value carries `template_medical_history-survey_name`,
 * and return that snapshot. If no record carries the snapshot (older
 * submissions saved before this feature shipped), return undefined and
 * the caller falls back to the live survey name.
 *
 * The write side is composeTemplatedMedicalHistoryValue() in
 * `composeTemplatedValue.ts`.
 */

interface RecordLike {
    surveyField?: { type?: string } | null;
    value?: unknown;
}

export function extractSurveyNameSnapshot(
    records: RecordLike[] | null | undefined,
): string | undefined {
    if (!records || !records.length) return undefined;
    for (const r of records) {
        if (r?.surveyField?.type !== 'medical_history_template') continue;
        if (!Array.isArray(r.value) || r.value.length === 0) continue;
        const snap = (r.value[0] as Record<string, unknown>)['template_medical_history-survey_name'];
        if (typeof snap === 'string' && snap.trim()) {
            return snap;
        }
    }
    return undefined;
}
